import { useEffect, useState } from "react";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  listAll,
  deleteObject,
} from "firebase/storage";
import { collection, addDoc } from "firebase/firestore";
import storage, {  db } from "../firebase";
import Header from "./Header";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { Button } from "react-bootstrap";

const ImageUploader = () => {
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [images, setImages] = useState([]);
  const [add,setadd]=useState(false);
  const [read,setread]=useState(false);

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setImageUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleImageUpload = () => {
    if (image) {
      const storageRef = ref(storage, `images/${image.name}`);
      const uploadTask = uploadBytesResumable(storageRef, image);

      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Get upload progress
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(`Upload is ${progress}% done`);
        },
        (error) => {
          console.error("Error uploading file: ", error);
        },
        () => {
          // Upload completed successfully, now get download URL
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            console.log("File available at", downloadURL);
            // Save downloadURL to Firebase Firestore
            addDoc(collection(db, "images"), { name: image.name, url: downloadURL });
            setImages([...images, { name: image.name, url: downloadURL }]);
            setImage(null);
            setImageUrl("");
          });
        }
      );
    }
  };


  const [imageUrls, nsetImageUrls] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log("load per",loading)

  useEffect(() => {
    setLoading(true);
    const imagesRef = ref(storage, "images");
    listAll(imagesRef)
      .then((res) => {
        const promises = res.items.map((item) => getDownloadURL(item));
        Promise.all(promises)
          .then((urls) => {
            const images = urls.map((url) => url );
            nsetImageUrls(images);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, []);




  const handleDelete = (url) => {
    const imageName = decodeURIComponent(url.substring(url.lastIndexOf('/') + 1));
  const storageRef = ref(storage, `images/${imageName}`);
  console.log("i name",storageRef)
    deleteObject(storageRef)
      .then(() => {
        setImageUrl((prevUrls) => prevUrls.filter((prevUrl) => prevUrl !== url));
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <div className="w-100 h-100">
      <Header />
      <div className="text-center">
        <NavBar />
      <h1>Home Part</h1>
      <Button onClick={()=>{setadd(!add);setread(false)}} className="m-1">Create/Add</Button>
      <Button onClick={()=>{setread(!read);setadd(false)}} className="m-1">Read</Button> 
      <Button className="m-1">Update</Button> 
      <Button className="m-1">Delete</Button>
      { add && (<><div>
          <h3>Add Images to caresoul</h3>
          <img src={imageUrl} alt="" height="200" />
          <br />
          <input type="file" onChange={handleFileChange} />
          <button type="button" onClick={handleImageUpload}>Upload</button>
        </div></>
       )
      }
      {
        read && (
          <div>
            {imageUrls.map((image) => (
              <><img className="m-2" src={image} alt="Loading" key={image} height="200" width="350" />
              <button className="btn btn-danger" onClick={() => handleDelete(image)}>Delete</button></>
            ))}
          </div>
        )
      }
      </div>
     
      <Footer />
    </div>
  );
};

export default ImageUploader;